import Colors from '../../../Configs/colors';

const styles = {
  white: {
    '&': {
      background: 'white',
    },
  },
  root: {
    '& .nav-container': {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      display: 'flex',
      justifyContent: 'center',
      border: 0,
      boxShadow: 'none',
      background: '#F7F7F7',
      '& .navigation': {
        background: '#FDFDFD',
        border: '1px solid #F5F6F8',
        borderBottom: 0,
      },
      '& .MuiBottomNavigationAction-label': {
        marginTop: 4,
        fontSize: 10,
      },
      '& .MuiBottomNavigationAction-label.Mui-selected': {
        // color: `${Colors.redDark} !important`,
        color: Colors.black,
        fontWeight: '700',
      },
    },
    '& main': {
      position: 'relative',
      // minHeight: '100vh',
      '& .filter-btns': {
        overflow: 'auto',
        '&::-webkit-scrollbar': {
          display: 'none',
        },
      },
      '& .filter-btn': {
        padding: '6px 8px',
        border: `1px solid ${Colors.grey}`,
        borderRadius: 8,
        cursor: 'pointer',
        whiteSpace: 'nowrap',
      },
      '& .upload-sect': {
        border: '1px dashed #6A6A6A',
        borderRadius: 8,
        background: '#F7F7FA',
        height: 120,
        width: 120,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#6A6A6A',
        cursor: 'pointer',
        '&.large': {
          width: 180,
        },
      },
    },
  },
};

export default styles;
